import speakersData2024 from './2024'
import speakersData2025 from './2025'

export const speakersData = {
  2024: speakersData2024,
  2025: speakersData2025,
}
